import React from 'react'
import { AlertTriangle } from 'lucide-react'

export default function BTCWarningCard({ timeframeLabel }: { timeframeLabel: string }) {
  return (
    <div className="mb-3 rounded-md border border-amber-500/30 bg-amber-500/10 p-3">
      <div className="flex items-start gap-2 text-sm text-amber-200">
        <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
        <div>
          <span className="font-semibold">Atenção:</span>{' '}
          Bitcoin iniciou correção no tempo gráfico {timeframeLabel}. Trades em tempos gráficos menores nas alt‑coins podem ser comprometidos devido à correção do Bitcoin.
        </div>
      </div>
    </div>
  )
}

